import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useState, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import keycode from 'keycode';
import ReactDayPicker, { LocaleUtils, DateUtils } from 'react-day-picker';
import { useGaudiLocalization } from '../Provider/Provider.js';

var _excluded = ["showYearControls", "showTodayButton", "month", "onDayClick"];

var getNextYear = function getNextYear(month) {
  return DateUtils.addMonths(month, 12);
};

var getPreviousYear = function getPreviousYear(month) {
  return DateUtils.addMonths(month, -12);
};

var handleKeyDown = function handleKeyDown(handler) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (event) {
    if (event.keyCode !== keycode('enter') && event.keyCode !== keycode('space')) {
      return;
    }

    event.preventDefault();
    handler.apply(void 0, args);
  };
};

var renderDay = function renderDay(day, modifiers) {
  return modifiers.disabled ? createElement("span", {
    className: "dot"
  }) : day.getDate();
};

var Navbar = function Navbar(_ref) {
  var month = _ref.month,
      onMonthChange = _ref.onMonthChange,
      onNextClick = _ref.onNextClick,
      onPreviousClick = _ref.onPreviousClick,
      showYearControls = _ref.showYearControls;

  var _useGaudiLocalization = useGaudiLocalization(),
      actions = _useGaudiLocalization.texts.calendar.actions,
      locale = _useGaudiLocalization.locale;

  return createElement("div", {
    className: "yt-calendar__navbar"
  }, showYearControls && createElement("span", {
    onClick: function onClick() {
      return onMonthChange(getPreviousYear(month));
    },
    tabIndex: 0,
    role: "button",
    "aria-label": actions.previousYear,
    onKeyDown: handleKeyDown(onMonthChange, getPreviousYear(month))
  }, createElement(Icon, {
    name: "chevron-left-double"
  })), createElement("span", {
    onClick: function onClick() {
      return onPreviousClick();
    },
    tabIndex: 0,
    role: "button",
    "aria-label": actions.previousMonth,
    onKeyDown: handleKeyDown(onPreviousClick)
  }, createElement(Icon, {
    name: "chevron-left"
  })), createElement("div", {
    className: "calendar-caption"
  }, month.toLocaleDateString(locale, {
    month: 'long',
    year: 'numeric'
  })), createElement("span", {
    onClick: function onClick() {
      return onNextClick();
    },
    tabIndex: 0,
    role: "button",
    "aria-label": actions.nextMonth,
    onKeyDown: handleKeyDown(onNextClick)
  }, createElement(Icon, {
    name: "chevron-right"
  })), showYearControls && createElement("span", {
    onClick: function onClick() {
      return onMonthChange(getNextYear(month));
    },
    tabIndex: 0,
    role: "button",
    "aria-label": actions.nextYear,
    onKeyDown: handleKeyDown(onMonthChange, getNextYear(month))
  }, createElement(Icon, {
    name: "chevron-right-double"
  })));
};

var formatWeekdayShort = function formatWeekdayShort(localization) {
  return function (weekDay) {
    var weekdaysShort = localization.texts.calendar.weekdaysShort;

    switch (weekDay) {
      case 0:
        return weekdaysShort.sunday;

      case 1:
        return weekdaysShort.monday;

      case 2:
        return weekdaysShort.tuesday;

      case 3:
        return weekdaysShort.wednesday;

      case 4:
        return weekdaysShort.thursday;

      case 5:
        return weekdaysShort.friday;

      case 6:
        return weekdaysShort.saturday;

      default:
        return '';
    }
  };
};

var Calendar = /*#__PURE__*/forwardRef(function Calendar(props, ref) {
  var showYearControls = props.showYearControls,
      showTodayButton = props.showTodayButton,
      monthProp = props.month,
      _onDayClick = props.onDayClick,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _React$useState = useState(monthProp),
      month = _React$useState[0],
      setMonth = _React$useState[1];

  var localization = useGaudiLocalization();
  var locale = localization.locale;
  var className = cn('yt-calendar', otherProps.className);
  return createElement(ReactDayPicker, Object.assign({}, otherProps, {
    className: className,
    month: month,
    locale: locale.substring(0, 2),
    localeUtils: _extends({}, LocaleUtils, {
      getFirstDayOfWeek: function getFirstDayOfWeek() {
        return 1;
      },
      formatWeekdayShort: formatWeekdayShort(localization)
    }),
    navbarElement: function navbarElement(navProps) {
      return createElement(Navbar, Object.assign({}, navProps, {
        showYearControls: showYearControls,
        onMonthChange: setMonth
      }));
    },
    onDayClick: function onDayClick(date, modifiers, event) {
      if (modifiers.outside || modifiers.disabled) {
        return;
      }

      if (_onDayClick) {
        _onDayClick(date, modifiers, event);
      }
    },
    captionElement: function captionElement() {
      return null;
    },
    todayButton: showTodayButton ? localization.texts.calendar.actions.today : undefined,
    showOutsideDays: true,
    renderDay: renderDay,
    numberOfMonths: 1,
    ref: ref
  }));
});

export { Calendar };
//# sourceMappingURL=Calendar.js.map
